import { createSlice } from "@reduxjs/toolkit";

const notificationSlice = createSlice({
  name: "notifications",
  initialState: {
    list: [],
    count: 0,
    initialized: false,
  },
  reducers: {
    setNotifications: (state, action) => {
      state.list = action.payload;
    },

    appendNotifications: (state, action) => {
      state.list = [...state.list, ...action.payload];
    },

    addNotification: (state, action) => {
      state.list.unshift(action.payload);
      state.count += 1;
    },

    updateNotification: (state, action) => {
      const index = state.list.findIndex(
        (n) => n.notification_id === action.payload.notification_id
      );
      if (index !== -1) {
        state.list[index] = action.payload;
      }
    },

    deleteNotification: (state, action) => {
      state.list = state.list.filter(
        (n) => n.notification_id !== action.payload
      );
      // ❌ No count decrement — WebSocket handles it
    },

    setNotificationCount: (state, action) => {
      state.count = action.payload;
      state.initialized = true;
    },

    // ✅ Seeds count only once before WebSocket fires
    seedNotificationCount: (state, action) => {
      if (!state.initialized) {
        state.count = action.payload;
      }
    },
  },
});

export const {
  setNotifications,
  appendNotifications,
  addNotification,
  updateNotification,
  deleteNotification,
  setNotificationCount,
  seedNotificationCount,
} = notificationSlice.actions;

export default notificationSlice.reducer;